<template>
    <div>
        <stations-list />
    </div>
</template>

<script>
import StationsList from './StationsList.vue'

export default {
    name: 'StationsLayout',
    components: {
        StationsList,
    },
}
</script>

<style scoped></style>
